module.exports = __webpack_public_path__ + "img/DefiStakingPlatform_logo_transparent-v3.5fd020eb.png";